/**
 * Some third-party widgets (Stamped reviews, etc.) inject their own
 * <iframe> into the DOM asynchronously, without an accessible title,
 * and we don't control their markup. This watches the document for
 * iframes matching a known selector and sets a descriptive title on
 * them as soon as they appear, however long after page load that is.
 */

// Translated titles from window.accessibilityStrings (layout/theme.liquid), English fallback
const IFRAME_TITLES = [
  {
    // Class only: the launcher is not always a <button> element
    selector: '.stamped-launcher-button iframe',
    getTitle: () => window.accessibilityStrings?.loyaltyLauncherIframe || 'Button loyalty chat',
  },
  {
    selector: 'div.stamped-rewards-base iframe',
    getTitle: () =>
      window.accessibilityStrings?.loyaltyWidgetIframe ||
      'Chatbot interactive with agent to know loyalty status',
  },
];

const applyTitle = (iframe) => {
  const match = IFRAME_TITLES.find(({ selector }) => iframe.matches(selector));
  if (!match) return;

  const title = match.getTitle();
  if (iframe.getAttribute('title') !== title) {
    iframe.setAttribute('title', title);
  }
};

const scanNode = (node) => {
  if (!(node instanceof Element)) return;

  if (node.tagName === 'IFRAME') {
    applyTitle(node);
  }

  node.querySelectorAll?.('iframe').forEach(applyTitle);
};

export const watchThirdPartyIframeTitles = () => {
  document.querySelectorAll('iframe').forEach(applyTitle);
  // Widgets may add their wrapper class after inserting the iframe: scan again once loaded
  window.addEventListener('load', () => document.querySelectorAll('iframe').forEach(applyTitle));

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach(scanNode);
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
};
